var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourseAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Course Status"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "backdrop",
    cx: 21,
    cy: 21.5,
    r: 15.75,
    fill: "#193051"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M18.1243 24.2427C19.7344 23.5877 21.2763 23.2602 22.75 23.2602C24.2237 23.2602 25.7519 23.5877 27.3348 24.2427C28.9449 24.8704 29.75 25.7027 29.75 26.7398V28.5H15.75V26.7398C15.75 25.7027 16.5414 24.8704 18.1243 24.2427ZM25.2061 20.4766C24.5239 21.1589 23.7052 21.5 22.75 21.5C21.7948 21.5 20.9761 21.1589 20.2939 20.4766C19.6116 19.7943 19.2705 18.9756 19.2705 18.0205C19.2705 17.0653 19.6116 16.2466 20.2939 15.5643C20.9761 14.8548 21.7948 14.5 22.75 14.5C23.7052 14.5 24.5239 14.8548 25.2061 15.5643C25.8884 16.2466 26.2295 17.0653 26.2295 18.0205C26.2295 18.9756 25.8884 19.7943 25.2061 20.4766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "arrow",
    d: "M17.5 21.5L13.3 18V20.5455H10.5V22.4545H13.3V25L17.5 21.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseAssigned);
export default __webpack_public_path__ + "static/media/course-assigned.ece377a406f8d9fe4070647e4a9726f7.svg";
export { ForwardRef as ReactComponent };